import React from 'react';

import ItemUtils from '../../../apps/UgcWall/utils/item-utils';
import * as DisplayItemUtils from '../../../common/components/displayItems/utils';
import Enums from '../config/enums';

function itemFactory({
  id,
  templateOpts,
  moduleOpts,
  itemOpts,
  assetUrl,
  assetUgcUrl,
  item,
  onClick,
  onExternalLinkClick,
  tabIndex,
  isOverlay,
}) {
  // Define the Item component class to render.
  const ItemComponent = ItemUtils.getItemComponent(templateOpts, isOverlay);

  // TODO: remove this TEMP hack when WYN-1603 (smart image sizing) is done.
  const res =
    moduleOpts.type === Enums.COLLAGE || moduleOpts.type === Enums.SOCIAL_CONTENT_CAROUSEL ? 'medium' : 'small';

  const itemAsset = isOverlay ?
    DisplayItemUtils.getItemDetailAsset(item, assetUrl, assetUgcUrl, moduleOpts, itemOpts) :
    DisplayItemUtils.getItemAsset({ item, assetUrl, assetUgcUrl, moduleOpts, itemOpts, res });

  // Output platform actions.
  let platformActions;
  if (item.actions.platform) {
    platformActions = DisplayItemUtils.getPlatformActions(item, itemOpts);
  }

  // Define any additional actions to output alongside the network/sharing actions.
  const additionalActions = DisplayItemUtils.getAdditionalActions(item);

  // Output network actions OR sharing actions, but not both (seemed to be how this was handled previously, not sure why yet...)
  // [SG] Because in the case of Tweets, we don't output the cross network sharing, only the Twitter actions
  let networkActions;
  let sharingActions;

  if (item.actions.network) {
    networkActions = DisplayItemUtils.getNetworkActions(
      item,
      itemOpts,
      additionalActions,
      undefined,
      onExternalLinkClick
    );
  } else {
    if (item.actions.sharing) {
      sharingActions = DisplayItemUtils.getSharingActions(
        item,
        itemOpts,
        additionalActions,
        'mode.overlay',
        onExternalLinkClick
      );
    }
  }

  return (
    <ItemComponent
      key={item.id}
      id={id}
      item={item}
      itemAsset={itemAsset}
      moduleOpts={moduleOpts}
      templateOpts={templateOpts}
      itemOpts={itemOpts}
      networkActions={networkActions}
      sharingActions={sharingActions}
      onClick={onClick}
      assetUrl={assetUrl}
      assetUgcUrl={assetUgcUrl}
      onExternalLinkClick={onExternalLinkClick}
      platformActions={platformActions}
      isOverlay={isOverlay}
      tabIndex={tabIndex}
    />
  );
}

export default itemFactory;
